import Vue from 'vue'
import VueI18n from "vue-i18n";

Vue.use(VueI18n, )

const i18n = new VueI18n({
  locale: 'gb-eng',
  silentFallbackWarn: true,
  messages: {
    'gb-eng': {
      "certificates-table": 'Certificates table',
      'filters-and-alternatives': 'Filters and alternatives',
      'apply-filter': 'Apply filter',
      'logout': 'Logout',
      'register-device':'Register Device',
      'device-table':'Device table',
      'filters': 'filters',
    },
    'se': {
      "certificates-table": 'Certifikattabell',
      'filters-and-alternatives': 'Filter och alternativ',
      'apply-filter': 'Använd filter',
      'logout': 'Logga ut',
      'register-device':'Registrera enhet',
      'device-table':'Enhetstabell',
      'filters': 'filtrar',
      '': '',
    },
    'th': {
      "certificates-table": 'ตารางใบรับรอง',
      'filters-and-alternatives': 'ตัวกรองและทางเลือก',
      'apply-filter': 'ใช้ตัวกรอง',
      'logout': 'ออกจากระบบ',
      'register-device': 'ลงทะเบียนอุปกรณ์',
      'device-table':'ตารางอุปกรณ์',
      '':'',
    },
    'pl': {
      "certificates-table": 'Tabela certyfikatów',
      'filters-and-alternatives': 'Filtry i alternatywy',
      'apply-filter': 'Nałóż filtr',
      'logout': 'Wyloguj',
      'register-device':'Zarejestruj urządzenie',
      'device-table': 'Tabela urządzeń',
      '':'',
    },
  }
})

export default i18n;